module.exports = __webpack_public_path__ + "static/img/banner_zoology.ccfa792.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_zoology.png
// module id = /Q0l
// module chunks = 15